import React from 'react'

export default function Registry() {
    return (
        <div>
            <p className='font-view'>
                While we don't have a real registry, the one thing we truly want is more experiences together. Some of our ideas was to go to Japan, Ireland, England, Disney World, the list goes on. Helping us fill our vacation jar would be more than enough!
                <br /><br />
                <a href='https://account.venmo.com/u/Maureen-Fenninger'>
                    Click here for VenMO! (haha get it?)
                </a>
            </p>
        </div>
    )
}
